export default __webpack_public_path__ + "static/media/card_execucao.fc53f6c8.svg";